// IBKR model readings are per option, not position-scaled exposures.
const valid = value => typeof value === 'number' && Number.isFinite(value)
export function optionGreekDisplay(snapshot, session, now) {
  const data = snapshot?.contract?.secType === 'OPT' ? snapshot.optionGreeks : null
  const current = data?.current
  const closing = data?.closing
  const open = session === 'regular'
  const reading = open ? current : closing && closing.sessionClose <= now ? closing : null
  const live = open && reading?.live === true && reading.marketDataType === 1
    && snapshot?.freshness === 'live' && now >= reading.receivedAt && now - reading.receivedAt <= 120000
    && now < reading.sessionClose
  const label = open ? live ? 'Live' : [3, 4].includes(reading?.marketDataType) ? 'Delayed' : reading ? 'Stale' : 'Unavailable' : reading ? 'Saved close' : 'Closing values unavailable'
  const stamp = reading && valid(reading.receivedAt) ? new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', second: '2-digit', timeZoneName: 'short' }).format(reading.receivedAt) : ''
  const values = Object.fromEntries(['delta', 'theta', 'vega', 'iv'].map(key => {
    const value = reading?.[key]
    return [key, valid(value) ? key === 'iv' ? `${(value * 100).toFixed(1)}%` : value.toFixed(3).replace('-', '−') : '—']
  }))
  return { label, stamp, values, live, persistenceAvailable: data?.persistenceAvailable !== false }
}
